import { render, staticRenderFns } from "./MailTemplateGeneralInfo.vue?vue&type=template&id=ad11ed2c&scoped=true"
import script from "./MailTemplateGeneralInfo.vue?vue&type=script&lang=js"
export * from "./MailTemplateGeneralInfo.vue?vue&type=script&lang=js"
import style0 from "./MailTemplateGeneralInfo.vue?vue&type=style&index=0&id=ad11ed2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad11ed2c",
  null
  
)

export default component.exports